// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Point} from './point.js'
import {SeqId} from './seq-id.js'

export class CanvasAnchor {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CanvasAnchor {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  page(obj?: SeqId): SeqId | null {
    return (obj || new SeqId()).__init(this.bb_pos, this.bb!)
  }

  origin(obj?: Point): Point | null {
    return (obj || new Point()).__init(this.bb_pos + 12, this.bb!)
  }

  static sizeOf(): number {
    return 20
  }

  static createCanvasAnchor(
    builder: flatbuffers.Builder,
    page_site: number,
    page_timestamp: number,
    page_index: number,
    origin_x: number,
    origin_y: number
  ): flatbuffers.Offset {
    builder.prep(4, 20)
    builder.prep(4, 8)
    builder.writeFloat32(origin_y)
    builder.writeFloat32(origin_x)
    builder.prep(4, 12)
    builder.writeInt32(page_index)
    builder.writeInt32(page_timestamp)
    builder.pad(2)
    builder.writeInt16(page_site)
    return builder.offset()
  }
}
